module.exports = __webpack_public_path__ + "img/solution-electric-components-pic.37aed9df.png";